<template>
	<div class="bigbox cursorstyle">
		<!-- <div class="bannder">
			<img :src="fromdata.resource_file" >
		</div> -->
		<div class="nav cursorstyleObjBtn">
			当前位置：<span @click="userObj.routeClick('3')" class="navBoxTxt"> 首页 </span> >
					<span @click="userObj.routeClick('1')" class="navBoxTxt">
						<span v-if="this.$route.query.type == 'notice'||this.$route.query.type == '1'">通知公告</span>
						<span v-if="this.$route.query.type == 'standard'||this.$route.query.type == '3'">相关规范</span>
						<span v-if="this.$route.query.type == 'tables'||this.$route.query.type == '4'">常用表格</span>
					</span> >
					
			<!-- <span v-if="this.$route.query.type == 'notice'||this.$route.query.type == '1'">通知公告</span>
			<span v-if="this.$route.query.type == 'standard'||this.$route.query.type == '3'">相关规范</span>
			<span v-if="this.$route.query.type == 'tables'||this.$route.query.type == '4'">常用表格</span>
		 -->
      <span>
		 {{fromdata.name}}
			</span>
		</div>
		<p class="title">{{fromdata.name}}</p>
		<!-- 表单 -->
		<div class="tablebox">
			<p>{{fromdata.name}}</p>
      <div class="textbox" v-html="fromdata.content"></div>
		</div>
	</div>
</template>

<script>
	import {
		// 通知公告
		gitinformationListObj,
	} from '@/api/Achievements.js'
	
	export default {
		data() {
			return {
				fromdata:{}
			}
		},
		mounted() {
			this.informationLists()
		},
		methods: {
			// 通知公告
			async informationLists() {
				let obj = {id:this.$route.query.ids}
				let res = await gitinformationListObj(obj)
				if (res.code == '00000') {
					this.fromdata = res.data
				}

			},

		}
	}
</script>

<style scoped="scoped" lang="less">
	.bigbox {
		width: 63vw;
		margin: 0 auto;
		// border: 1px red solid;
	}

	.bannder {
		width: 100%;
		height: 326px;
		background: #D8D8D8;
		margin: 0 auto;
		margin-top: 14px;
		img{
			width: 100%;
			height: 100%;
		}
	}

	.nav {
		margin-top: 14px;
		font-size: 16px;
		color: #333333;
	}

	.title {
		font-size: 18px;
		font-weight: bold;
		color: #333333;
		margin-top: 10px;
	}

	.tablebox {
		height: 1058px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 4px rgba(0, 0, 0, 0.07);
		margin-top: 20px;
		overflow: hidden;

		p {
			font-weight: 400;
			//color: #DF3E3E;
      color: #333333;
			font-size: 36px;
			text-align: center;
			margin-top: 59px;
		}

		.textbox {
			width: 96%;
			font-size: 14px;
			font-weight: 400;
			color: #333333;
			margin: 0 auto;
			margin-top: 53px;
		}
	}
</style>
